import { ActivityFilterId } from './types'

export const searchActivity = (payload: string) =>
  ({ type: 'activity.search', payload } as const)
export type SearchActivityAction = ReturnType<typeof searchActivity>

export const filterActivity = (payload: ActivityFilterId) =>
  ({ type: 'activity.filter', payload } as const)
export type FilterActivityAction = ReturnType<typeof filterActivity>

export const toggleActivityPanel = () =>
  ({ type: 'activity.toggle-visibility' } as const)
export type ToggleActivityPanelAction = ReturnType<typeof toggleActivityPanel>

export type ActivityAction =
  | SearchActivityAction
  | FilterActivityAction
  | ToggleActivityPanelAction
